import { render, staticRenderFns } from "./RecentView.vue?vue&type=template&id=481676cc&"
import script from "./RecentView.vue?vue&type=script&lang=js&"
export * from "./RecentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports